import React, { Component } from "react";
import '../LandingPage/LandingPageStyleSheet.css';
import dayjs from "dayjs";
// import { InView } from 'react-intersection-observer'
// import HWLog from "../HWLibrary/HWLog";

class ConversationListCell extends Component {

    render() {
        let lastMessage = (this.props.conversation.lastMessage && this.props.conversation.lastMessage.text) || ""
        let timeStampString = (this.props.conversation && Math.trunc(this.props.conversation.createdOn/1000));
        let displayTime = (timeStampString) ? dayjs.unix(timeStampString).format("MMM D, YYYY h:mm a") : null;
        let agentDisplayName = (this.props.conversation.agentInfo && this.props.conversation.agentInfo.shortName) || "Chat Bot";
        let statusColor = (this.props.conversation && this.props.conversation.agentInfo && this.props.conversation.agentInfo.isActive === true) ? "#00FF00" : "red";
        let placeholderPic = this.props.config.configDetails.chatCellIcon && this.props.config.configDetails.chatCellIcon !== ""?this.props.config.configDetails.chatCellIcon:"https://hummingwave-image-util.s3.amazonaws.com/agent-3x.png";
        let agentProfilePic     = (this.props.conversation && this.props.conversation.agentInfo && this.props.conversation.agentInfo.userProfilePic) || placeholderPic;
        return (
            // <InView onChange={(inView, entry) => { this.onViewStateChange(inView) }} >  
            //     {({ inView, ref, entry }) => (
                    <div className="s360-conversation-history-list-cell">
                        <div className="s360-conversation-history-container" style={this.conversationStyle()} onClick={this.showConversation} >
                            <div className="s360-conversation-history-agent-image-container">
                                <div className="s360-conversation-history-agent-image-cell">
                                    <img src={agentProfilePic} className="s360-conversation-history-agent-image-cell-image" width="50px" height="50px"  />
                                    <div className="s360-conversation-header-agent-ping-status-container"><div className="s360-conversation-list-header-agent-ping-status" style={{ backgroundColor: statusColor}} ></div></div>
                                </div>
                            </div>
                            <div className="s360-conversation-history-agent-detail-container">
                                <div className="s360-conversation-history-agent-detail-cell" style={this.agentDetailStyle()}>
                                    <div className="s360-conversation-history-agent-details-name" style={this.agentNameStyle()}>
                                        {agentDisplayName}
                                    </div>
                                    <div className="s360-conversation-history-agent-message">
                                        {lastMessage}
                                    </div>

                                </div>
                            </div>
                            <div className="s360-conversation-history-time-container">
                                <div className="s360-conversation-history-agent-message-time" style={this.agentTimeStyle()}>
                                    {displayTime}
                                </div>
                            </div>
                        </div>
                    </div>
            //     )}
            // </InView>
        )
    }

    conversationStyle = () => {
        return {
            backgroundColor: this.props.config.designDetails.pageBackgroundColor,
        }
    }

    showConversation = () => {
        this.props.actions.startConversation(this.props.conversation);
    }

    agentDetailStyle = () => {
        return {
            backgroundColor: this.props.config.designDetails.pageBackgroundColor,
            display: "flex",
            flexDirection: "column",
            marginLeft: "10px"
        }
    }

    agentNameStyle = () => {
        return {
            color: this.props.config.designDetails.headerColor
        }
    }

    agentTimeStyle = () => {
        return {

        }
    }

    onViewStateChange = (inView) => {
        if (inView) {
            this.startFetchingHealthPings();
        } else {
            this.stopFetchingHealthPings();
        }
    }

    // MARK: AGENT HEALTH PING: 
    // Start fetching health ping for every 10 seconds. Stop heath ping time on component unmount.
    // agentHealthPingTimerId = null;
    // startFetchingHealthPings = () => {
    //     let sessionId = (this.props.conversation && this.props.conversation.sessionId);
    //     if (!sessionId) { HWLog.warn("No Session Id Available To Fetch Agent Health Ping: "); return; }
    //     this.props.fetchAgentHealthPing(sessionId);
    //     this.agentHealthPingTimerId = setInterval(async () => {
    //         this.props.fetchAgentHealthPing(sessionId);
    //     }, 10000)
    // }

    // stopFetchingHealthPings = () => {
    //     if (this.agentHealthPingTimerId) { clearInterval(this.agentHealthPingTimerId); }
    // }

}

export default ConversationListCell;